import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import PartChatDialog from "@/components/PartChatDialog";
import { MessagesHeader } from "../components/conversation/Header";
import { MessagesLoading } from "../components/conversation/MessagesLoading";
import { MessagesEmpty } from "../components/conversation/MessagesEmpty";
import { ConversationsList } from "../components/conversation/ConversationList";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchConversations,
  fetchMessages,
  updateIsRead
} from "../store/partChat/partChatActions";
import { useToast } from "../components/ui/use-toast";
import { useNavigate } from "react-router-dom";

const MessagesPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { toast } = useToast();
  const [selectedConversation, setSelectedConversation] = useState(null);
  const { isAuthenticated, user } = useSelector((state) => state.auth);
  const {
    conversations,
    isConversation,
    messages,
    isMessagesLoading,
    isSenderLoading
  } = useSelector((state) => state.partChat);

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.1, duration: 0.5 }
    }
  };

  const handleConversationClick = (conversation) => {
    setSelectedConversation(conversation);

    dispatch(
      fetchMessages({
        buyerId: user?.uid,
        sellerId: conversation?.otherUserDetail?.id,
        partId: conversation?.partId,
        currentUserId: user?.uid
      })
    );
    dispatch(
      updateIsRead({
        currentUserId: user?.uid,
        receiverId: conversation?.otherUserDetail?.id,
        partId: conversation?.partId
      })
    );
  };

  useEffect(() => {
    if (!isAuthenticated || !user) {
      if (!isAuthenticated) {
        toast({
          title: "Login Required",
          description: "Please login to view messeges.",
          variant: "destructive"
        });
      }
      navigate("/");
      return;
    }
  }, []);

  useEffect(() => {
    dispatch(fetchConversations({ userId: user?.uid }));
  }, []);

  return (
    <>
      <motion.div
        className="space-y-8 w-full max-w-4xl mx-auto"
        initial="hidden"
        animate="visible"
        variants={containerVariants}
      >
        <MessagesHeader userRole={user?.role} title={"Messages"} />

        {isConversation && <MessagesLoading />}

        {!isConversation && conversations?.length === 0 && (
          <MessagesEmpty userRole={user?.role} />
        )}

        {!isConversation && conversations?.length > 0 && (
          <ConversationsList
            conversations={conversations}
            userRole={user?.role}
            onConversationClick={handleConversationClick}
          />
        )}
      </motion.div>

      {selectedConversation && (
        <PartChatDialog
          messages={messages}
          conversation={selectedConversation}
          isOpen={!!selectedConversation}
          isMessagesLoading={isMessagesLoading}
          isSenderLoading={isSenderLoading}
          onOpenChange={(open) => {
            if (!open) setSelectedConversation(null);
          }}
        >
          <></>
        </PartChatDialog>
      )}
    </>
  );
};

export default MessagesPage;
